import { object, string } from "yup";

export const BookServiceValidation = (t) =>
  object().shape({
    phone_number: string()
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t("telephoneError1"))
      .matches(/^(5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t("telephoneError2"))
      .min(9)
      .max(9)
      .required(t("TelephoneRequired")),
    first_name: string().required(t("firstnameRequired")),
    last_name: string().required(t("lastnameRequired")),
    company: string().required(t("companyRequired")),
    email: string()
      .matches(
        /^(05\d{8}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
        t("emailMobileValidation")
      )
      .required(t("emailMobileRequired")),
  });
